import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import ListPagination from './components/Pagination';
import ListHeader from './components/Header';
import { LOAD_MORE } from '../../constants';
import { useAppSyncEventHook } from '../../hooks';
import { buildQueryBooster } from './helpers';
const ListRender = props => {
  const {
    variables,
    actionKey,
    action,
    name,
    itemsToDisplay,
    itemsPerPageToUse,
    limitToUse,
    initialOffset,
    isInfinite,
    omitWrappers,
    paginationType,
    listComponent: ListComponent,
    query,
    url,
    listAggregations,
    isAZ,
    azFilter,
    displayTotal
  } = props;
  const {
    data: updatedVariables
  } = useAppSyncEventHook({
    eventName: 'list:query-variables',
    data: variables,
    props
  });
  const boostedVariables = buildQueryBooster(props, updatedVariables);
  const {
    data = {},
    error,
    loading,
    fetchMore
  } = useQuery(action, {
    variables: boostedVariables
  });
  if (loading) return '';
  if (error) return error.message;
  if (!data[actionKey] || !data[actionKey].results) return null;
  const listData = data[actionKey].results;
  const listTotal = data[actionKey].total;
  if (!listData || !listData.length) return null;
  const {
    length: currentListLength
  } = listData;
  const currentPage = Math.ceil((initialOffset + currentListLength) / itemsPerPageToUse);
  const totalDisplay = limitToUse && listTotal > limitToUse ? limitToUse : listTotal;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "list-top"
  }), isAZ && /*#__PURE__*/React.createElement(ListHeader, {
    name: name,
    listAggregations: listAggregations,
    azFilter: azFilter
  }), displayTotal && /*#__PURE__*/React.createElement("div", {
    className: "list_total_results w-full text-left p-4"
  }, "Total results: ", totalDisplay), /*#__PURE__*/React.createElement(ListComponent, _extends({
    orderedListData: listData,
    isInfinite: isInfinite,
    initialOffset: initialOffset,
    actionKey: actionKey,
    limitToUse: limitToUse,
    fetchMore: fetchMore,
    omitWrappers: omitWrappers,
    itemsPerPageToUse: itemsPerPageToUse || listData.length,
    listTotal: listTotal,
    currentListLength: currentListLength,
    currentPage: currentPage,
    query: query,
    url: url,
    itemsToDisplay: itemsToDisplay
  }, props)), paginationType !== LOAD_MORE && /*#__PURE__*/React.createElement(ListPagination, {
    limitToUse: limitToUse,
    itemsPerPage: itemsPerPageToUse,
    listTotal: listTotal,
    name: name,
    isInfinite: isInfinite,
    currentListLength: currentListLength,
    paginationType: paginationType,
    currentPage: currentPage,
    query: query,
    url: url
  }));
};
ListRender.propTypes = {
  name: PropTypes.string.isRequired,
  paginationType: PropTypes.string.isRequired,
  variables: PropTypes.object.isRequired,
  actionKey: PropTypes.string.isRequired,
  action: PropTypes.object.isRequired,
  itemsPerPageToUse: PropTypes.number.isRequired,
  limitToUse: PropTypes.number.isRequired,
  initialOffset: PropTypes.number.isRequired,
  isInfinite: PropTypes.bool.isRequired,
  omitWrappers: PropTypes.bool,
  query: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  listComponent: PropTypes.func.isRequired,
  isAZ: PropTypes.bool.isRequired,
  azFilter: PropTypes.string.isRequired,
  listAggregations: PropTypes.array,
  itemsToDisplay: PropTypes.array,
  displayTotal: PropTypes.bool
};
ListRender.defaultProps = {
  omitWrappers: false,
  itemsToDisplay: [],
  listAggregations: [],
  displayTotal: false
};
export default ListRender;
//# sourceMappingURL=ListRender.js.map